import {Component, EventEmitter, forwardRef, Input, OnChanges, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'app-tab-selector',
    templateUrl: './tab-selector.component.html',
    styleUrls: ['./tab-selector.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TabSelectorComponent),
            multi: true
        }
    ]
})
export class TabSelectorComponent implements ControlValueAccessor, OnChanges {
    @Input() options: { label: string, value: any, color?: string }[] = [];
    @Input() defaultValue?: number;
    @Output() tabChange: EventEmitter<any> = new EventEmitter<any>();
    selectedIndex: number = 0;

    private onChange!: (value: any) => void;
    private onTouched!: () => void;

    ngOnChanges(): void {
        if (this.defaultValue != null && this.selectedIndex != this.defaultValue) {
            this.writeValue(this.defaultValue);
        }
    }

    writeValue(value: any): void {
        if (value) {
            const index: number = this.options.findIndex(option => option.value === value);
            this.selectedIndex = index !== -1 ? index : 0;
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    onTabChange(index: number): void {
        const value = this.options[index]?.value;
        this.onChange(value);
        this.onTouched();
        this.tabChange.emit(value);
    }
}
